import { Component } from '@angular/core';

@Component({
  selector: 'app-toggle-panel-playground',
  templateUrl: './toggle-panel-playground.component.html',
  styleUrls: ['./toggle-panel-playground.component.scss'],
})
export class TogglePanelPlaygroundComponent {
  activeLabel = 'Sí';
  inactiveLabel = 'No';
  checked = false;
  disabled = false;
  /** `false` = sin borde (elevación al hover), alineado a `common-panel`. */
  showPanelBorder = true;
  lastEvent = '';

  onChange(value: boolean): void {
    this.lastEvent = `change → ${value} @ ${new Date().toLocaleTimeString()}`;
  }
}
